export const CHANGE_ROOT = 'CHANGE_ROOT'

export function changeRoot(rootNode) {
  return (dispatch, getState) => {
    dispatch({
      type: CHANGE_ROOT,
      payload: rootNode
    })
  }
}
const ACTION_HANDLERS = {
  [CHANGE_ROOT]: (state, action) => state.child(action.payload)
}
// ------------------------------------
// Reducer
// ------------------------------------
const initialState = {
  firebase: ''
}
export default function authReducer(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type]

  return handler ? handler(state, action) : state
}



// WEBPACK FOOTER //
// ./src/redux/modules/firebase.js